import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  DatastoreUserDocumentSubmissionsModule,
  DatastoreUserVerificationProcessesModule,
  DatastoreVerificationProcessTypesModule,
} from '@freelancer/datastore/collections';
import { PipesModule } from '@freelancer/pipes';
import { UiModule } from '@freelancer/ui';
import { GroupsCommonModule } from 'app/groups/groups-common/groups-common.module';
import { LicenseUploadFormModule } from './license-upload-form/license-upload-form.module';
import { SubmitDocumentsConfirmModalModule } from './submit-documents-confirm-modal/submit-documents-confirm-modal.module';
import { VerificationProcessNotFoundComponent } from './verification-process-not-found/verification-process-not-found.component';
import { VerificationProcessSubmittedComponent } from './verification-process-submitted/verification-process-submitted.component';
import { VerificationsDocumentsComponent } from './verifications-documents/verifications-documents.component';
import { VerificationsHeaderComponent } from './verifications-header.component';
import { VerificationsRoutingModule } from './verifications-routing.module';
import { VerificationsUploadComponent } from './verifications-upload/verifications-upload.component';

@NgModule({
  imports: [
    CommonModule,
    DatastoreVerificationProcessTypesModule,
    DatastoreUserDocumentSubmissionsModule,
    DatastoreUserVerificationProcessesModule,
    LicenseUploadFormModule,
    SubmitDocumentsConfirmModalModule,
    GroupsCommonModule,
    PipesModule,
    UiModule,
    VerificationsRoutingModule,
  ],
  declarations: [
    VerificationsHeaderComponent,
    VerificationsDocumentsComponent,
    VerificationsUploadComponent,
    VerificationProcessNotFoundComponent,
    VerificationProcessSubmittedComponent,
  ],
  exports: [
    VerificationsDocumentsComponent,
    VerificationsUploadComponent,
    VerificationProcessNotFoundComponent,
  ],
})
export class VerificationsModule {}
